import { Form } from "antd"
import type { FormInstance } from "antd/es/form/hooks/useForm"

import type { DocumentTemplateBlock } from "../types/types.ts"

// One shared reference, so a template with no blocks yet cannot invalidate a
// caller's `useMemo` on every render.
const NO_BLOCKS: DocumentTemplateBlock[] = []

/**
 * A template's blocks, re-read on every change under `blocks`.
 *
 * `Form.useWatch` is the trigger and never the value: it rebuilds a watched
 * parent path from registered fields alone, so a block that registers nothing
 * of its own under `config` comes back as a hole in the array.
 */
export function useTemplateBlocks(form: FormInstance): DocumentTemplateBlock[] {
  Form.useWatch("blocks", form)
  return form.getFieldValue("blocks") ?? NO_BLOCKS
}
